module.exports = __webpack_public_path__ + "img/wind.785d66ad.svg";